import { render, staticRenderFns } from "./registrationMethod.vue?vue&type=template&id=3d7eba36&scoped=true&"
import script from "./registrationMethod.vue?vue&type=script&lang=js&"
export * from "./registrationMethod.vue?vue&type=script&lang=js&"
import style0 from "./registrationMethod.vue?vue&type=style&index=0&id=3d7eba36&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7eba36",
  null
  
)

export default component.exports